import { createFileRoute } from "@tanstack/react-router";
import RequestAccess from "@/pages/RequestAccess";

const URL = "https://www.homeapproach.com/request-access";
const TITLE = "Request Home Approach Through Your Employer";
const DESC = "Home Approach is a homeownership benefit offered through employers. Tell us where you work and we'll reach out to bring it to you.";

export const Route = createFileRoute("/request-access")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <RequestAccess />,
});
